export const css = {
    root: '_2bmpP7nm',
    tool: 'lLnfgbGu',
    completed: '_1j59xFHF',
    active: 'PXjWF6FT',
    disabled: 'j0STknw6',
    navlabel: '_2vvQy722',
    extra: '_3sZc6O7r',
    complete: '_1HkdTchh',
    ' _key': 'lp-widgets/lptool'
};
export default css;
